export default __webpack_public_path__ + "static/media/cqe.3489b9ba.svg";